module.exports = __webpack_public_path__ + "img/icon-divide.bb4573b9.svg";